export const DEFAULT_START_TIME = null;
export const DEFAULT_END_TIME = null;
export const DEFAULT_STEP_MINUTES = 30;
